/**
 * RESPONSIBILITY: read a stored `YYYY-MM-DD` as a day in the reader's own calendar.
 *
 * `new Date('2026-10-04')` is UTC midnight — the evening before in Austin — which labels
 * Sunday's bulletin as Saturday's and files a sermon under the wrong day. One reading of
 * a date string, here, so the bulletin and the sermons cannot disagree about it (rule 12).
 */
export function localDay(iso: string | undefined): Date | null {
  const [y, m, d] = (iso ?? '').split('-').map(Number);
  if (!y || !m || !d) return null;
  const day = new Date(y, m - 1, d);
  return day.getMonth() === m - 1 ? day : null;
}
